<template>
  <!-- Main Content -->
  <div class="page-wrapper">
    <div class="container-fluid">

      <!-- Title -->
      <div class="row heading-bg">
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
          <h5 class="txt-dark">
            <back-button link="/main/tickets"></back-button> 
            Update ticket: {{ form.id }}<loading :isLoading="isLoading"></loading>
          </h5>
        </div>
        <!-- Breadcrumb -->
        <div class="col-lg-8 col-sm-8 col-md-8 col-xs-12">
          <ol class="breadcrumb">
            <li><router-link to="/">Dashboard</router-link></li>
            <li>Data Center</li>
            <li><router-link to="/main/tickets">Tickets</router-link></li>
            <li class="active">Update</li>
          </ol>
        </div>
        <!-- /Breadcrumb -->
      </div>
      <!-- /Title -->

      <!-- Row -->
      <div class="row">
        <div class="col-md-6">
          <div class="panel panel-default card-view">
            <div class="panel-wrapper collapse in">
              <div class="panel-body">
                <div class="row">
                  <div class="col-sm-12 col-xs-12">
                     <div class="form-wrap form-horizontal">
                      <div class="form-group">
                        <label class="col-sm-3 control-label">Tickets Type</label>
                        <div class="col-sm-9">
                          <my-select :selection.sync="form.ticket_type_id" :suggestions="ticketTypes" placeholder="Select Ticket Types"></my-select>
                          <span class="error-block">{{ errors.ticket_type_id }}</span>
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-sm-3 control-label">Description</label>
                        <div class="col-sm-9">
                          <textarea v-uppercase class="form-control" placeholder="Description" v-model="form.description"></textarea>
                          <span class="error-block">{{ errors.description }}</span>
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-sm-3 control-label">Status</label>
                        <div class="col-sm-9">
                          <select class="form-control" placeholder="Status" v-model="form.status">
                            <option>Select Status</option>
                            <option value="0">Open</option>
                            <option value="1">Closed</option>
                          </select>
                          <!-- <input v-uppercase type="text" class="form-control" placeholder="Status" v-model="form.status"> -->
                          <span class="error-block">{{ errors.status }}</span>
                        </div>
                      </div>
                      <div class="form-group mb-0">
                        <div class="col-sm-offset-3 col-sm-9">
                          <submit-button :isLoading="isLoading" @submit="update" text="Update"></submit-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>  
        </div>
      </div>
      <!-- /Row -->
    </div>

  </div>
  <!-- /Main Content -->
</template>

<script type="text/javascript">
import axios from 'axios'

export default {
  name: 'TicketUpdate',
  data () {
    return {
      form: {
        ticket_type_id: '',
      },
      ticketTypes: [],
      isLoading: false,
    }
  },
  mounted() {
    this.getData()
    this.getMasters()
  },
  methods: {
    async getMasters() {
      let masters = await axios.get('tickets/masters')
      masters = masters.data
      masters.ticketTypes.forEach(ticket_type => {
        this.ticketTypes.push({
          id: ticket_type.id,
          name: ticket_type.description
        })
      })
    },
    async getData() {
      this.isLoading = true
      let form = await axios.get(`/tickets/${this.$route.params.ticketId}`)
      this.form = form.data.data
      this.isLoading = false
    },
    async update() {
      try {
        this.isLoading = true
        await axios.patch(`/tickets/${this.$route.params.ticketId}`, this.form)
        this.isLoading = false
        this.$router.push('/main/tickets')
      } catch(e) {
        this.isLoading = false
      }
    }
  }
}
</script>